import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA026_Request,
  IAPI_STA026_Response,
  IAPI_STA011_Request,
  IAPI_STA011_Response,
} from "../../../type/apiType";

// 共済契約対象（外）施設等異動　対象者一覧参照
// 法人職員
const httpAPI_STA026 = async (
  param: IAPI_STA026_Request
): Promise<IAPI_STA026_Response> => {
  let res = await http.post(ApiUrl.API_STA026, {
    ...param,
  });

  return res.data;
};

// 配置換え職員一覧更新
// API仕様書_法人職員
const httpAPI_STA011 = async (
  param: IAPI_STA011_Request
): Promise<IAPI_STA011_Response> => {
  let res = await http.post(ApiUrl.API_STA011, {
    ...param,
  });

  return res.data;
};
export { httpAPI_STA026, httpAPI_STA011 };
